"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
const errors_1 = require("../errors");
const logger_1 = require("../interfaces/logger");
const spark_md5_1 = __importDefault(require("spark-md5"));
const uploadProtocol_1 = require("../transport/uploadProtocol");
// Native module for fragmented WebSocket uploads (Android only)
let nativeUploadFile = null;
try {
    const mod = require('../../../modules/nextpda-native-transport/src');
    nativeUploadFile = mod.nativeUploadFile;
}
catch {
    // Not available (web/iOS) — will fall back to transport.upload
}
const uploadLogger = new logger_1.VoidLogger();
class Service {
    constructor(transport, auth) {
        this.transport = transport;
        this.auth = auth;
    }
    checkError(response, command) {
        if (response.status !== 0) {
            throw new errors_1.FourPdaError(response.status, command, undefined, response.data);
        }
    }
    /**
     * Upload a file to 4PDA.
     * Uses native module (Android) for fragmented WebSocket frames,
     * or falls back to transport.upload() for other platforms.
     * @param fileData Uint8Array of the file content
     * @param fileName Name of the file
     * @param onProgress Optional progress callback (0-100)
     * @returns Promise<number> File ID
     */
    async uploadFile(fileData, fileName, onProgress, _isQms = false) {
        const cleanBuffer = fileData.buffer.slice(fileData.byteOffset, fileData.byteOffset + fileData.byteLength);
        const cleanData = new Uint8Array(cleanBuffer);
        const md5 = spark_md5_1.default.ArrayBuffer.hash(cleanBuffer).toUpperCase();
        const size = cleanData.length;
        // Try native module first (Android — supports fragmented WebSocket frames)
        if (nativeUploadFile && this.auth) {
            const memberId = String(this.auth.userId || 0);
            const loginKey = this.auth.loginKey || '';
            const cookies = `member_id=${memberId}; pass_hash=${loginKey}`;
            if (memberId !== '0' && loginKey) {
                uploadLogger.info(`Using native upload module for: ${fileName}`);
                onProgress?.(10);
                try {
                    const fileId = await nativeUploadFile(cookies, memberId, loginKey, fileName, size, md5, cleanData);
                    onProgress?.(100);
                    return fileId;
                }
                catch (e) {
                    uploadLogger.warn(`Native upload failed: ${e.message}, falling back to transport`);
                    // Fall through to transport-based upload
                }
            }
        }
        // Fallback: transport-based upload (works with NodeWebSocketTransport)
        const checkRes = await this.transport.send('fu', (0, uploadProtocol_1.buildFuSendArgs)(fileName, size, md5, _isQms));
        if (checkRes.status === 0) {
            onProgress?.(100);
            return checkRes.data[0] || checkRes.id;
        }
        if (checkRes.status === 4) {
            const memberId = this.auth?.userId || 0;
            const sessionKey = (0, uploadProtocol_1.resolveUploadSessionKey)(checkRes.data?.[0], memberId);
            if (!this.transport.upload) {
                throw new Error('Transport does not support binary upload');
            }
            const uploadRes = await this.transport.upload('su', (0, uploadProtocol_1.buildSuUploadParams)(sessionKey, fileName, size, md5, _isQms), cleanData, (p) => {
                onProgress?.(p);
            });
            uploadLogger.debug('Upload Stream (su) Response:', uploadRes);
            if (uploadRes.status === 0) {
                onProgress?.(100);
                return uploadRes.data[0];
            }
            throw new errors_1.FourPdaError(uploadRes.status, 'su', undefined, uploadRes.data);
        }
        throw new errors_1.FourPdaError(checkRes.status, 'fu', undefined, checkRes.data);
    }
}
exports.Service = Service;
